"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rulesApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function rulesApiClient(networkClient) {
    return {
        // Campaign
        createCampaignRule: async (params, body) => {
            return networkClient.postHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules`, body);
        },
        deleteCampaignRule: async (params) => {
            return networkClient.deleteHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/${params.ruleId}`);
        },
        listCampaignRules: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules`, query, config);
        },
        updateCampaignRule: async (params, body) => {
            return networkClient.putHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/${params.ruleId}`, body);
        },
        setCampaignRuleMapping: async (params, body) => {
            return networkClient.putHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/${params.ruleId}/mapping`, body);
        },
        updateCampaignRulePriorities: async (params, body) => {
            return networkClient.putHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/priority`, body);
        },
        // Region
        createRegionRule: async (params, body) => {
            return networkClient.postHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/region`, body);
        },
        deleteRegionRule: async (params) => {
            return networkClient.deleteHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/${params.ruleId}/region`);
        },
        listRegionRules: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/region`, query, config);
        },
        updateRegionRule: async (params, body) => {
            return networkClient.putHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/${params.ruleId}/region`, body);
        },
        setRegionRuleMapping: async (params, body) => {
            return networkClient.putHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/${params.ruleId}/region/mapping`, body);
        },
        updateRegionRulePriorities: async (params, body) => {
            return networkClient.putHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/region/priority`, body);
        },
        // Keyword
        createKeywordRule: async (params, body) => {
            return networkClient.postHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/keyword`, body);
        },
        deleteKeywordRule: async (params) => {
            return networkClient.deleteHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/${params.ruleId}/keyword`);
        },
        listKeywordRules: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/keyword`, query, config);
        },
        updateKeywordRule: async (params, body) => {
            return networkClient.putHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/${params.ruleId}/keyword`, body);
        },
        setKeywordRuleMapping: async (params, body) => {
            return networkClient.putHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/${params.ruleId}/keyword/mapping`, body);
        },
        updateKeywordRulePriorities: async (params, body) => {
            return networkClient.putHttp(data_lib_1.RULES_WEB_SERVICE, `/api/v2/rules/teams/${params.teamId}/campaigns/${params.campaignId}/rules/keyword/priority`, body);
        },
    };
}
exports.rulesApiClient = rulesApiClient;
